/**
 * NepalxAI — Image URL helper
 * Converts any image path (relative, wrong-host, or bare filename)
 * into the correct public URL at register.biheybari.com
 */
const IMAGE_HOST = 'https://register.biheybari.com';

export function imageUrl(path) {
  if (!path) return null;
  const p = String(path).trim();
  if (!p) return null;

  // Absolute URL → rewrite host if needed
  if (/^https?:\/\//i.test(p)) {
    return p
      .replace(/^https?:\/\/localhost(:\d+)?/i, IMAGE_HOST)
      .replace(/^https?:\/\/127\.0\.0\.1(:\d+)?/i, IMAGE_HOST)
      .replace(/^http:\/\//i, 'https://');
  }

  // Relative path
  if (p.startsWith('/')) return `${IMAGE_HOST}${p}`;
  if (p.startsWith('uploads/')) return `${IMAGE_HOST}/${p}`;

  // Bare filename
  return `${IMAGE_HOST}/uploads/${p}`;
}

export default imageUrl;